import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Update active section based on scroll position
      const sections = ['hero', 'about', 'approach', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleAboutDropdown = () => {
    setShowAboutDropdown(!showAboutDropdown);
  };

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navigation-container">
        <button 
          className="navigation-logo"
          onClick={handleLogoClick}
          aria-label="Tara Ventures Home"
        >
          <img 
            src="https://aiwugigdrvijjeoqtpog.supabase.co/storage/v1/object/public/dharma-images/website-tv/tv-logo-cropped.png"
            alt="Tara Ventures" 
            className="logo-image"
          />
        </button>

        <ul className="navigation-menu">
          <li 
            className="dropdown-container"
            onMouseEnter={() => setShowAboutDropdown(true)}
            onMouseLeave={() => setShowAboutDropdown(false)}
          >
            <button
              className={`navigation-link ${activeSection === 'about' || activeSection === 'approach' || activeSection === 'contact' ? 'active' : ''}`}
              onClick={toggleAboutDropdown}
            >
              About ▾
            </button>
            {showAboutDropdown && (
              <ul className="dropdown-menu">
                <li>
                  <button
                    className="dropdown-link"
                    onClick={() => {
                      scrollToSection('about');
                      setShowAboutDropdown(false);
                    }}
                  >
                    About
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-link"
                    onClick={() => {
                      scrollToSection('approach');
                      setShowAboutDropdown(false);
                    }}
                  >
                    Approach
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-link"
                    onClick={() => {
                      scrollToSection('contact');
                      setShowAboutDropdown(false);
                    }}
                  >
                    Contact
                  </button>
                </li>
              </ul>
            )}
          </li>
          <li>
            <button
              className={`navigation-link ${activeSection === 'projects' ? 'active' : ''}`}
              onClick={() => scrollToSection('projects')}
            >
              Projects
            </button>
          </li>
          <li>
            <button
              className={`navigation-link ${location.pathname === '/founder' ? 'active' : ''}`}
              onClick={() => navigate('/founder')}
            >
              Founder
            </button>
          </li>
          <li>
            <button
              className={`navigation-link ${location.pathname === '/careers' ? 'active' : ''}`}
              onClick={() => navigate('/careers')}
            >
              Careers
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;